<template>
  <div class="variable-element">
    <div class="variable-header">
      <span class="variable-type-badge">
        <i class="fas fa-code"></i>
        <span>Variable</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <i class="fas fa-copy"></i>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>
    
    <div class="variable-content">
      <div class="variable-form">
        <div class="form-row">
          <div class="variable-select-container">
            <div class="select-wrapper">
              <i class="fas fa-code tag-icon"></i>
              <select 
                v-model="selectedVariable" 
                class="variable-select"
                @change="handleVariableChange"
              >
                <option value="" disabled>Sélectionnez une variable</option>
                <option 
                  v-for="variable in filteredVariables" 
                  :key="variable.id" 
                  :value="variable.id"
                >
                  {{variable.id}}
                </option>
              </select>
            </div>
          </div>
          
          <div class="variable-input-container">
            <div class="input-wrapper">
              <i class="fas fa-equals tag-icon"></i>
              <input 
                type="text" 
                v-model="defaultValue"
                class="variable-input"
                placeholder="Valeur par défaut"
                @input="handleValueChange"
              >
            </div>
          </div>
        </div>
        <div class="variable-description">
          Définit la valeur de la variable
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VariableInsertElement',
  props: {
    element: {
      type: Object,
      required: true
    },
    variables: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedVariable: this.element.variable || '',
      defaultValue: this.element.defaultValue || ''
    }
  },
  computed: {
    filteredVariables() {
      return this.variables.filter(variable => variable.type !== 'global')
    }
  },
  methods: {
    handleVariableChange() {
      this.$emit('update', {
        ...this.element,
        variable: this.selectedVariable
      })
    },
    handleValueChange() {
      this.$emit('update', {
        ...this.element,
        defaultValue: this.defaultValue
      })
    }
  }
}
</script>

<style scoped>
.variable-element {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.variable-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: linear-gradient(to right, #f8fafc, #f1f5f9);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.variable-type-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #3b82f6;
  font-weight: 500;
}

.element-actions {
  display: flex;
  gap: 0.75rem;
}

.action-btn {
  background: white;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #64748b;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: #3b82f6;
}

.delete-btn:hover {
  background: #fef2f2;
  color: #ef4444;
}

.variable-content {
  padding: 1.25rem;
}

.variable-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.variable-select-container {
  flex: 2;
}

.variable-input-container {
  flex: 1;
}

.select-wrapper,
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border-radius: 12px;
  padding: 0.25rem;
  border: 2px solid #e2e8f0;
  transition: all 0.2s ease;
}

.select-wrapper:hover,
.input-wrapper:hover {
  border-color: #93c5fd;
  background: #ffffff;
}

.select-wrapper:focus-within,
.input-wrapper:focus-within {
  border-color: #3b82f6;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.tag-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dbeafe;
  color: #1d4ed8;
  border-radius: 8px;
  font-size: 0.75rem;
  margin: 0 0.25rem;
}

.variable-select,
.variable-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: #1e293b;
  outline: none;
}

.variable-select {
  appearance: none;
  padding-right: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1rem;
}

.variable-description {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 0.75rem;
  padding-left: 0.5rem;
}

.edit-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: white;
  border: 1px solid #93c5fd;
  border-radius: 6px;
  color: #3b82f6;
  font-size: 0.85rem;
  transition: all 0.2s ease;
}

.edit-button:hover {
  background: #eff6ff;
  color: #1e40af;
  border-color: #60a5fa;
}
</style>
